import * as z from "zod/v4";

export const tariffDiscrepancySeverity = z.enum(["high", "medium", "low"]);
export type TariffDiscrepancySeverity = z.infer<
  typeof tariffDiscrepancySeverity
>;

export const tariffDiscrepancy = z.object({
  field: z.string().min(1),
  expected: z.string(),
  actual: z.string(),
  severity: tariffDiscrepancySeverity,
});
export type TariffDiscrepancy = z.infer<typeof tariffDiscrepancy>;

export const productClassification = z.object({
  productType: z.string(),
  htsChapter: z.number(),
  chapterDescription: z.string(),
  confidence: z.enum(["high", "medium", "low"]),
  reasonForClassification: z.string(),
});
export type ProductClassification = z.infer<typeof productClassification>;

export const detectCustomsInvoiceDiscrepancies = {
  name: "detectCustomsInvoiceDiscrepancies" as const,
  input: z.object({
    teamId: z.string(), // can be fake for anonymous users
    imageData: z.string().min(1),
    fileName: z.string().optional(),
    fileSize: z.number().optional(),
    fileType: z.string().optional(),
    isPdf: z.boolean().optional().default(false),
  }),

  output: z.object({
    discrepancies: z.array(tariffDiscrepancy),
    overallRisk: z.enum(["high", "medium", "low"]),
    productClassification: productClassification.nullable(),
    analyzedAt: z.date(),
  }),
};
